import React from 'react'
import styled from 'styled-components'

import * as Colors from './Colors'

const Highlight = styled.span`
  padding: ${props => (props.size + 1 || 3) / 16}rem 0;
  color: ${props => props.color || 'inherit'};
  text-align: center;
  box-sizing: border-box;
  border-bottom: ${props => (props.size || 2) / 16}rem solid
    ${props => props.lineColor || Colors.C_Brand};
  ${props => (props.to || props.clickable ? 'cursor: pointer;' : '')};
`

export default Highlight



// WEBPACK FOOTER //
// ./src/components/Highlight.js